type CashChange = {
  T: number;
  P: number;
  V: number;
  C: number;
  I: number;
  Cbm: number;
  Cmr: number;
  Cr: number;
  Nwbm: number;
  Nwmr: number;
  Wbm: number;
  Wmr: number;
  UsedCredit: number;
  OpBuyPo: number;
  ToOpMa: number;
};

enum TraderStateEnum {
  Normal = 1,
  AtRisk = 2,
  MargiCall = 3,
}

type TraderStateChange = {
  TraderPamCode: string;
  TraderState: TraderStateEnum;
};

function transformCashChange(data: CashChange) {
  const {
    T: totalAsset,
    P: buyingPower,
    V: blockedValue,
    C: investorBourseCodeId,
    I: investorBourseCodeIsin,
    Cbm: creditBlockedMoney,
    Cmr: creditMoneyRemain,
    Cr: creditMoney,
    Nwbm: nonWithdrawableBlockedMoney,
    Nwmr: nonWithdrawableMoneyRemain,
    Wbm: withdrawableBlockedMoney,
    Wmr: withdrawableMoneyRemain,
    UsedCredit: usedCredit,
    OpBuyPo: optionBuyingPower,
    ToOpMa: totalOptionMargin,
  } = data;

  return {
    totalAsset,
    buyingPower: Math.floor(buyingPower),
    blockedValue,
    creditBlockedMoney,
    creditMoneyRemain,
    creditMoney,
    nonWithdrawableBlockedMoney,
    nonWithdrawableMoneyRemain,
    withdrawableBlockedMoney,
    withdrawableMoneyRemain,
    investorBourseCodeIsin,
    investorBourseCodeId,
    usedCredit,
    optionBuyingPower,
    totalOptionMargin,
  };
}

function transformTraderStateChange(data: TraderStateChange) {
  const { TraderPamCode: traderPamCode, TraderState: traderState } = data;

  return {
    traderState,
    traderPamCode,
  };
}

export { transformCashChange, transformTraderStateChange };
